import React from 'react';
import { MainHeadline, OuterWrapper, InnerWrapper, Paragraph } from 'styles/GlobalStyles';

export const Tech = () => {
  return (
    <OuterWrapper>
      <MainHeadline>TECH</MainHeadline>
      <InnerWrapper>
        <Paragraph>JavaScript, Typescript, React, React Hooks, HTML, CSS, Node.js, Express, Flexbox,
        Redux,  Mongo DB, Web Accessibility, Responsive Design, REST APIs, Mob-programming,
        Pair-programming, Git, C#, ASP.NET Core, Entity Framework Core, MS SQL Server.
        </Paragraph>
      </InnerWrapper>
    </OuterWrapper>
  )
}